var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronUpOutline = function SvgChevronUpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 16.76a1 1 0 101.3-1.52l-7-6a1 1 0 00-1.3 0l-7 6a1 1 0 001.3 1.52L14 11.316l6.35 5.442z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjM0OTIgMTYuNzU5MkMyMC43Njg1IDE3LjExODcgMjEuMzk5OCAxNy4wNzAxIDIxLjc1OTIgMTYuNjUwOEMyMi4xMTg3IDE2LjIzMTQgMjIuMDcwMSAxNS42MDAxIDIxLjY1MDggMTUuMjQwN0wxNC42NTA4IDkuMjQwNzNDMTQuMjc2MyA4LjkxOTczIDEzLjcyMzcgOC45MTk3MyAxMy4zNDkyIDkuMjQwNzNMNi4zNDkxOSAxNS4yNDA3QzUuOTI5ODYgMTUuNjAwMSA1Ljg4MTMgMTYuMjMxNCA2LjI0MDczIDE2LjY1MDhDNi42MDAxNSAxNy4wNzAxIDcuMjMxNDUgMTcuMTE4NyA3LjY1MDc3IDE2Ljc1OTJMMTQgMTEuMzE3MUwyMC4zNDkyIDE2Ljc1OTJaIiBmaWxsPSIjMDIzRjgwIi8+Cjwvc3ZnPgo=";
export { SvgChevronUpOutline as ReactComponent };